import {
  EsaMembershipCreditBalancesQuery,
  EsaMembershipCreditBalancesQueryVariables
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import React from "react";

export const esaMembershipCreditBalanceQuery = gql`
  query EsaMembershipCreditBalances {
    esaMembershipCreditBalances {
      ...EsaMembershipCreditBalancesFragment
    }
  }

  fragment EsaMembershipCreditBalancesFragment on EsaMembershipCreditBalance {
    uid
    availableCredits
    learner {
      uid
      name
    }
    fundingProgram {
      name
      isClassWallet
    }
  }
`;

export const useEsaMembershipCreditBalances = () => {
  const { isLoggedIn } = useSession();

  const { data, loading, refetch } = useQueryWithPreviousData<
    EsaMembershipCreditBalancesQuery,
    EsaMembershipCreditBalancesQueryVariables
  >(esaMembershipCreditBalanceQuery, {
    skip: !isLoggedIn
  });

  const creditBalances = React.useMemo(() => {
    const creditBalances = data?.esaMembershipCreditBalances ?? [];
    return creditBalances.map(creditBalance => ({
      availableCredits: creditBalance.availableCredits,
      name: creditBalance.learner.name,
      programName: creditBalance.fundingProgram.name,
      isClassWallet: creditBalance.fundingProgram.isClassWallet,
      uid: creditBalance.uid
    }));
  }, [data]);

  return {
    hasEsaMembershipCreditBalances: creditBalances.length > 0,
    creditBalances,
    loading,
    refetch
  };
};

type EsaMembershipCredit = ReturnType<typeof useEsaMembershipCreditBalances>;

export type EsaMembershipCreditBalance =
  EsaMembershipCredit["creditBalances"][number];
